export default "__VITE_ASSET__jnMQhM4j__"